import React from 'react';
import styles from './TourBookingMessage.module.css';
import { useNavigate } from 'react-router-dom';

interface TourBookingMessageProps {
    onClick?: () => void;
    onClose?: () => void;
}

const TourBookingMessage: React.FC<TourBookingMessageProps> = ({ onClick, onClose }) => {
    const navigate = useNavigate();
    const handleOkClick = () => {
        if (onClose) {
            onClose();
            return;
        }
        navigate('/appointments');
    };
    return (
        <div className={styles.tourBookingMessageContainer}>
            <div className={styles.tourMessageContent}>
                <div className={styles.infoText}>
                    <p className={styles.infoMessage}>
                        To book a tour, please visit the property's website or scan a tour QR code while on property.
                    </p>
                </div>
                <button className={styles.okButton} onClick={handleOkClick}>
                    <span className={styles.buttonText}>Ok</span>
                </button>
            </div>
        </div>
    );
};

export default TourBookingMessage;
